(function(){
    'use strict'

    angular.module('app.cuentasContables')
    .factory('CuentasContablesService', CuentasContablesService);

    CuentasContablesService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CuentasContablesService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/cuentas-contables/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, cuentaContableId){

            var url = apiSettings.apiBaseUrl + 'api/cuentas-contables/' + companiaId + '/' + cuentaContableId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(cuentaContable){

            cuentaContable.id = 0;
            cuentaContable.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cuentas-contables',  
                method: 'POST',  
                data: cuentaContable
            });  
            return response;
        };

        function update(cuentaContable){

            cuentaContable.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cuentas-contables',  
                method: 'PUT',  
                data: cuentaContable
            });  
            return response;
        };

        function remove(cuentaContable){

            cuentaContable.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cuentas-contables',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: cuentaContable
            });  
            return response;
        };

    };

})();